// extracted by mini-css-extract-plugin
module.exports = {"SendMoney":"SendMoney_SendMoney__upZnk"};